import {Component, ElementRef, ViewChild} from '@angular/core';
import {ContactUs} from "../../books/model/book-model";
import {ContactUsService} from "../../pages/contact-us/contact-us.service";
import {ModalComponent} from "../modal/modal.component";
import {Router} from "@angular/router";

@Component({
  selector: 'app-contact-us-modal',
  templateUrl: './contact-us-modal.component.html',
  standalone: false,
  styleUrl: './contact-us-modal.component.scss'
})
export class ContactUsModalComponent {

  contactUs = new ContactUs()
  @ViewChild('contactUsModal', { static: true }) contactUsModal: ModalComponent;

  @ViewChild('email', { static: false }) email: ElementRef;
  @ViewChild('msg', { static: false }) message: ElementRef;

  constructor(private contactUsService: ContactUsService,
              private router: Router) {}

  open() {
    this.contactUsModal.show()
  }

  onSubmit() {
    this.contactUsService.sendContactUs(this.contactUs)
      .subscribe(_ => {
        this.contactUsModal.hide()
        this.router.navigate(['/student/contact-us/result'])
      })
  }


}
